import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent } from "vue";
import NumericCalculator from "./NumericCalculator.vue";
import { setupAsideOrderSummary } from "./aside-order-summary";
import { hasCustomerDisplay, updateCustomerScreen } from "@/utils/vue-helpers/customer-display";
import copyIcon from "@/assets/images/svg/copy.svg";
import check from "@/assets/images/svg/green-check.svg";
import alertTriangleIcon from "@/assets/images/svg/alert-triangle.svg";
import { BookingType } from "@/types/db/product-slot-booking";
export default defineComponent({
  components: {
    NumericCalculator: NumericCalculator
  },
  name: "AsideOrderSummary",
  setup: function setup() {
    var _setupAsideOrderSumma = setupAsideOrderSummary(),
        getStatusTranslation = _setupAsideOrderSumma.getStatusTranslation,
        showRemoveBtn = _setupAsideOrderSumma.showRemoveBtn,
        showRemovePaymentBtn = _setupAsideOrderSumma.showRemovePaymentBtn,
        isInThePast = _setupAsideOrderSumma.isInThePast,
        showCancelTicketsModal = _setupAsideOrderSumma.showCancelTicketsModal,
        iconContent = _setupAsideOrderSumma.iconContent,
        iconAlt = _setupAsideOrderSumma.iconAlt,
        iconStyle = _setupAsideOrderSumma.iconStyle,
        printIcon = _setupAsideOrderSumma.printIcon,
        printAlt = _setupAsideOrderSumma.printAlt,
        t = _setupAsideOrderSumma.t,
        bookings = _setupAsideOrderSumma.bookings,
        bookingList = _setupAsideOrderSumma.bookingList,
        selectedBooking = _setupAsideOrderSumma.selectedBooking,
        currency = _setupAsideOrderSumma.currency,
        pssList = _setupAsideOrderSumma.pssList,
        isCompletedBooking = _setupAsideOrderSumma.isCompletedBooking,
        bookingStep = _setupAsideOrderSumma.bookingStep,
        BookingStep = _setupAsideOrderSumma.BookingStep,
        isInPaymentStep = _setupAsideOrderSumma.isInPaymentStep,
        isInOrderStep = _setupAsideOrderSumma.isInOrderStep,
        confirmedAmountsInfo = _setupAsideOrderSumma.confirmedAmountsInfo,
        confirmedAmountsTotal = _setupAsideOrderSumma.confirmedAmountsTotal,
        payingCurrency = _setupAsideOrderSumma.payingCurrency,
        getCustomerFullName = _setupAsideOrderSumma.getCustomerFullName,
        hasAppliedDiscount = _setupAsideOrderSumma.hasAppliedDiscount,
        isDiscountOnAllOrder = _setupAsideOrderSumma.isDiscountOnAllOrder,
        discountTotal1 = _setupAsideOrderSumma.discountTotal1,
        discountTotal = _setupAsideOrderSumma.discountTotal,
        whatIsLeftToPay = _setupAsideOrderSumma.whatIsLeftToPay,
        whatIsLeftToPayForInvoice = _setupAsideOrderSumma.whatIsLeftToPayForInvoice,
        total1 = _setupAsideOrderSumma.total1,
        total = _setupAsideOrderSumma.total,
        isLongTitle = _setupAsideOrderSumma.isLongTitle,
        isPSSConsideredInDiscount1 = _setupAsideOrderSumma.isPSSConsideredInDiscount1,
        isPSSConsideredInDiscount = _setupAsideOrderSumma.isPSSConsideredInDiscount,
        isFreeTicket = _setupAsideOrderSumma.isFreeTicket,
        PSSType = _setupAsideOrderSumma.PSSType,
        onClickCustomers = _setupAsideOrderSumma.onClickCustomers,
        getPSSNewPriceValue = _setupAsideOrderSumma.getPSSNewPriceValue,
        getTicketDiscount1 = _setupAsideOrderSumma.getTicketDiscount1,
        groupedPSSList = _setupAsideOrderSumma.groupedPSSList,
        deleteUnconfirmedTickets = _setupAsideOrderSumma.deleteUnconfirmedTickets,
        AccountingState = _setupAsideOrderSumma.AccountingState,
        deleteTickets = _setupAsideOrderSumma.deleteTickets,
        showTicketInfo = _setupAsideOrderSumma.showTicketInfo,
        formatDateTime = _setupAsideOrderSumma.formatDateTime,
        removePayment = _setupAsideOrderSumma.removePayment,
        deleteConfirmedAmount = _setupAsideOrderSumma.deleteConfirmedAmount,
        isAccountingCompleted = _setupAsideOrderSumma.isAccountingCompleted,
        doesSupportSplitPayment = _setupAsideOrderSumma.doesSupportSplitPayment,
        balance1 = _setupAsideOrderSumma.balance1,
        isEditOrder = _setupAsideOrderSumma.isEditOrder,
        alreadyPaidAmount = _setupAsideOrderSumma.alreadyPaidAmount,
        refundedAmount = _setupAsideOrderSumma.refundedAmount,
        refreshDiscount = _setupAsideOrderSumma.refreshDiscount,
        calcVisibility = _setupAsideOrderSumma.calcVisibility,
        calcIcon = _setupAsideOrderSumma.calcIcon,
        calcIconStyle = _setupAsideOrderSumma.calcIconStyle,
        calcAlt = _setupAsideOrderSumma.calcAlt,
        closeCalculator = _setupAsideOrderSumma.closeCalculator,
        BookingStatus = _setupAsideOrderSumma.BookingStatus,
        confirmedPSSToDelete = _setupAsideOrderSumma.confirmedPSSToDelete,
        DeleteIcon = _setupAsideOrderSumma.DeleteIcon,
        openMessageBox = _setupAsideOrderSumma.openMessageBox,
        closeModal = _setupAsideOrderSumma.closeModal,
        selectedConfirmedPssCount = _setupAsideOrderSumma.selectedConfirmedPssCount,
        isAllConfirmedPssSelected = _setupAsideOrderSumma.isAllConfirmedPssSelected,
        showCancelConfirmationModal = _setupAsideOrderSumma.showCancelConfirmationModal,
        cancelConfirmationCount = _setupAsideOrderSumma.cancelConfirmationCount,
        isConfirmedPssSelected = _setupAsideOrderSumma.isConfirmedPssSelected,
        toggleConfirmedPssSelection = _setupAsideOrderSumma.toggleConfirmedPssSelection,
        toggleSelectAllConfirmedPss = _setupAsideOrderSumma.toggleSelectAllConfirmedPss,
        bulkCancelSelectedTickets = _setupAsideOrderSumma.bulkCancelSelectedTickets,
        closeCancelConfirmationModal = _setupAsideOrderSumma.closeCancelConfirmationModal,
        confirmTicketsCancellation = _setupAsideOrderSumma.confirmTicketsCancellation,
        orderValueExcludingCancelledTickets = _setupAsideOrderSumma.orderValueExcludingCancelledTickets,
        splitPayments = _setupAsideOrderSumma.splitPayments,
        amountPaid = _setupAsideOrderSumma.amountPaid,
        translatePaymentMethods = _setupAsideOrderSumma.translatePaymentMethods,
        totalTax = _setupAsideOrderSumma.totalTax,
        PaymentMethods = _setupAsideOrderSumma.PaymentMethods,
        bookingSynchingDateTime = _setupAsideOrderSumma.bookingSynchingDateTime,
        hasGenericDiscountAccountings = _setupAsideOrderSumma.hasGenericDiscountAccountings,
        groupCurrency = _setupAsideOrderSumma.groupCurrency,
        currenciesUsedInPayment = _setupAsideOrderSumma.currenciesUsedInPayment,
        getPSSValue = _setupAsideOrderSumma.getPSSValue,
        getPackageTotalValue = _setupAsideOrderSumma.getPackageTotalValue,
        isRemoveButtonLoading = _setupAsideOrderSumma.isRemoveButtonLoading,
        getTicketAppliedDiscountCodes = _setupAsideOrderSumma.getTicketAppliedDiscountCodes,
        orderReference = _setupAsideOrderSumma.orderReference,
        copyToClipboard = _setupAsideOrderSumma.copyToClipboard,
        showCopyCheck = _setupAsideOrderSumma.showCopyCheck,
        getPssGroupDiscount = _setupAsideOrderSumma.getPssGroupDiscount,
        getTicketAppliedOffers = _setupAsideOrderSumma.getTicketAppliedOffers,
        printBill = _setupAsideOrderSumma.printBill,
        showPrintBill = _setupAsideOrderSumma.showPrintBill;

    return {
      getStatusTranslation: getStatusTranslation,
      showRemoveBtn: showRemoveBtn,
      showRemovePaymentBtn: showRemovePaymentBtn,
      isInThePast: isInThePast,
      showCancelTicketsModal: showCancelTicketsModal,
      iconContent: iconContent,
      iconAlt: iconAlt,
      iconStyle: iconStyle,
      printIcon: printIcon,
      printAlt: printAlt,
      t: t,
      bookings: bookings,
      bookingList: bookingList,
      selectedBooking: selectedBooking,
      currency: currency,
      pssList: pssList,
      isCompletedBooking: isCompletedBooking,
      bookingStep: bookingStep,
      BookingStep: BookingStep,
      isInPaymentStep: isInPaymentStep,
      isInOrderStep: isInOrderStep,
      confirmedAmountsInfo: confirmedAmountsInfo,
      confirmedAmountsTotal: confirmedAmountsTotal,
      payingCurrency: payingCurrency,
      getCustomerFullName: getCustomerFullName,
      hasAppliedDiscount: hasAppliedDiscount,
      isDiscountOnAllOrder: isDiscountOnAllOrder,
      discountTotal1: discountTotal1,
      discountTotal: discountTotal,
      whatIsLeftToPay: whatIsLeftToPay,
      whatIsLeftToPayForInvoice: whatIsLeftToPayForInvoice,
      BookingType: BookingType,
      total1: total1,
      total: total,
      isLongTitle: isLongTitle,
      isPSSConsideredInDiscount1: isPSSConsideredInDiscount1,
      isPSSConsideredInDiscount: isPSSConsideredInDiscount,
      isFreeTicket: isFreeTicket,
      PSSType: PSSType,
      onClickCustomers: onClickCustomers,
      getPSSNewPriceValue: getPSSNewPriceValue,
      getTicketDiscount1: getTicketDiscount1,
      groupedPSSList: groupedPSSList,
      deleteUnconfirmedTickets: deleteUnconfirmedTickets,
      AccountingState: AccountingState,
      deleteTickets: deleteTickets,
      showTicketInfo: showTicketInfo,
      formatDateTime: formatDateTime,
      removePayment: removePayment,
      deleteConfirmedAmount: deleteConfirmedAmount,
      isAccountingCompleted: isAccountingCompleted,
      doesSupportSplitPayment: doesSupportSplitPayment,
      balance1: balance1,
      isEditOrder: isEditOrder,
      alreadyPaidAmount: alreadyPaidAmount,
      refundedAmount: refundedAmount,
      refreshDiscount: refreshDiscount,
      calcVisibility: calcVisibility,
      calcIcon: calcIcon,
      calcIconStyle: calcIconStyle,
      calcAlt: calcAlt,
      closeCalculator: closeCalculator,
      // paidAccountingsSum,
      BookingStatus: BookingStatus,
      confirmedPSSToDelete: confirmedPSSToDelete,
      DeleteIcon: DeleteIcon,
      openMessageBox: openMessageBox,
      closeModal: closeModal,
      selectedConfirmedPssCount: selectedConfirmedPssCount,
      isAllConfirmedPssSelected: isAllConfirmedPssSelected,
      showCancelConfirmationModal: showCancelConfirmationModal,
      cancelConfirmationCount: cancelConfirmationCount,
      isConfirmedPssSelected: isConfirmedPssSelected,
      toggleConfirmedPssSelection: toggleConfirmedPssSelection,
      toggleSelectAllConfirmedPss: toggleSelectAllConfirmedPss,
      bulkCancelSelectedTickets: bulkCancelSelectedTickets,
      closeCancelConfirmationModal: closeCancelConfirmationModal,
      confirmTicketsCancellation: confirmTicketsCancellation,
      orderValueExcludingCancelledTickets: orderValueExcludingCancelledTickets,
      splitPayments: splitPayments,
      amountPaid: amountPaid,
      translatePaymentMethods: translatePaymentMethods,
      totalTax: totalTax,
      PaymentMethods: PaymentMethods,
      bookingSynchingDateTime: bookingSynchingDateTime,
      hasGenericDiscountAccountings: hasGenericDiscountAccountings,
      groupCurrency: groupCurrency,
      currenciesUsedInPayment: currenciesUsedInPayment,
      getPSSValue: getPSSValue,
      getPackageTotalValue: getPackageTotalValue,
      isRemoveButtonLoading: isRemoveButtonLoading,
      getTicketAppliedDiscountCodes: getTicketAppliedDiscountCodes,
      copyIcon: copyIcon,
      alertTriangleIcon: alertTriangleIcon,
      orderReference: orderReference,
      copyToClipboard: copyToClipboard,
      check: check,
      showCopyCheck: showCopyCheck,
      getPssGroupDiscount: getPssGroupDiscount,
      getTicketAppliedOffers: getTicketAppliedOffers,
      printBill: printBill,
      showPrintBill: showPrintBill
    };
  },
  created: function created() {// console.log("hi from created of order summary()");
    // console.log("********* nowDB()");
    // console.log(nowDB());
  },
  mounted: function mounted() {// console.log("hi from mounted of order summary()");
    // console.log("********* nowDB()");
    // console.log(nowDB());
    // this.specialWhatIsLeftToPay = (BookingModule.leftToPayAmount / 100).toFixed(
    //   2
    // );
  },
  updated: function updated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log("hi from updated of AsideOrderSummary");

              if (!hasCustomerDisplay.value) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return updateCustomerScreen();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
});